import { useState } from 'react'
import { Button, StatusMessage, TextField } from '@krp/ui-kit'
import type { CashierPolicy } from '../model/types'

export interface CashierSetCodeScreenProps {
  /** Правила кода с сервера; пока не пришли, код не принимается. */
  rules?: CashierPolicy | undefined
  /** Отправляет токен и код; успех — имя кассира, отказ — текст сервера дословно. */
  submit: (token: string, pin: string) => Promise<{ ok: true; cashierName: string } | { ok: false; message: string }>
}
/**
 * «Задать свой код»: кассир вводит токен приглашения от администратора и придумывает код сам; администратор кода не узнаёт.
 * Токен и код живут только в полях этой страницы, очищаются при отправке и не попадают в Redux, адрес и журнал.
 */
export function CashierSetCodeScreen(props: CashierSetCodeScreenProps) {
  const [token, setToken] = useState('')
  const [pin, setPin] = useState('')
  const [repeat, setRepeat] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [done, setDone] = useState<string | null>(null)
  const lengthOk = props.rules !== undefined && pin.length >= props.rules.pinMinLength && pin.length <= props.rules.pinMaxLength
  const valid = token.replace(/[^0-9A-Za-z]/g, '').length === 12 && /^[0-9A-Za-z]+$/.test(pin) && lengthOk && repeat === pin
  const send = async () => {
    if (!valid || busy) return
    const sentToken = token; const sentPin = pin
    setToken(''); setPin(''); setRepeat(''); setError(null); setBusy(true)
    try {
      const result = await props.submit(sentToken, sentPin)
      if (result.ok) setDone(result.cashierName); else setError(result.message)
    } finally { setBusy(false) }
  }
  if (done !== null) return <section className="cashier-access" aria-label="Задать свой код">
    <h3>✓ Код задан</h3>
    <p role="status">{done}, теперь вы входите по своему коду. Прежний код по умолчанию больше не действует.</p>
  </section>
  return <section className="cashier-access" aria-label="Задать свой код">
    <p>Администратор выдал вам приглашение. Введите его и придумайте свой код: администратор его не узнает.</p>
    {error !== null && <StatusMessage kind="error" title="Код не задан" text={error} />}
    <fieldset disabled={busy}>
      <TextField label="Приглашение" actionId="receipts.cashier-access.redeem" value={token} onChange={setToken} />
      <TextField label="Ваш новый код" type="password" actionId="receipts.cashier-access.redeem" value={pin} onChange={setPin} />
      <TextField label="Повторите код" type="password" actionId="receipts.cashier-access.redeem" value={repeat} onChange={setRepeat} />
      <p>{props.rules === undefined ? 'Правила кода загружаются…' : `От ${props.rules.pinMinLength} до ${props.rules.pinMaxLength} знаков: цифры и латинские буквы, как в штрихкоде бейджа.`} Простые коды не принимаются.</p>
      {repeat !== '' && repeat !== pin && <p role="status">Коды не совпадают.</p>}
      <Button variant="primary" actionId="receipts.cashier-access.redeem" busy={busy} disabled={!valid} onClick={() => void send()}>Задать код</Button>
    </fieldset>
  </section>
}
